/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  getProspects,
  getOutreachCredits,
  searchProspects,
  revealProspects,
  sendOutreachEmails,
  setApolloCredits,
  toggleIgnoreProspect,
} from '../actions/outreach';
import { OutreachState } from '../types/outreach';

const initialState: OutreachState = {
  prospects: [],
  total: 0,
  totalPages: 0,
  page: 1,
  summary: undefined,
  credits: undefined,
  isFetching: false,
  isSearching: false,
  isRevealing: false,
  isSending: false,
};

const outreachSlice = createSlice({
  name: 'outreach',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProspects.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getProspects.fulfilled, (state, action) => {
        state.isFetching = false;
        state.prospects = action.payload.prospect_list ?? [];
        state.total = action.payload.total ?? 0;
        state.totalPages = action.payload.total_pages ?? 0;
        state.page = action.payload.page ?? 1;
        state.summary = action.payload.summary;
      })
      .addCase(getProspects.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(searchProspects.pending, (state) => {
        state.isSearching = true;
      })
      .addCase(searchProspects.fulfilled, (state) => {
        state.isSearching = false;
      })
      .addCase(searchProspects.rejected, (state) => {
        state.isSearching = false;
      })
      .addCase(revealProspects.pending, (state) => {
        state.isRevealing = true;
      })
      .addCase(revealProspects.fulfilled, (state) => {
        state.isRevealing = false;
      })
      .addCase(revealProspects.rejected, (state) => {
        state.isRevealing = false;
      })
      .addCase(sendOutreachEmails.pending, (state) => {
        state.isSending = true;
      })
      .addCase(sendOutreachEmails.fulfilled, (state) => {
        state.isSending = false;
      })
      .addCase(sendOutreachEmails.rejected, (state) => {
        state.isSending = false;
      })
      .addCase(getOutreachCredits.fulfilled, (state, action) => {
        state.credits = action.payload;
      })
      .addCase(setApolloCredits.fulfilled, (state, action) => {
        state.credits = action.payload;
      })
      .addCase(toggleIgnoreProspect.fulfilled, (state, action) => {
        const { prospectId, is_ignored: isIgnored } = action.payload;
        const p = state.prospects.find((x) => x.id === prospectId);
        if (p) (p as any).is_ignored = isIgnored;
      });
  },
});

export default outreachSlice.reducer;
